<template>
    <div>
        <div v-if="pauseAllowed" class="border-b border-black">
            <div v-if="canBePaused" @click="$emit('paused')" class="deliveryAddressCard__action">
                <p class="no-margin" v-text="$t('MANAGE_DELIVERY_PAUSE')"></p>
                <img class="deliveryAddressCard__actionIcon" src="@/assets/images/decoration/nav-pause.png">
            </div>

            <resume-deliveries v-else :subscription="subscription"/>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { SUBSCRIPTION_STATUS_ACTIVE } from '@/constants/Subscription';
import ResumeDeliveries from '@/components/partials/account/my-delivery-schedule/manage-delivery/ResumeDeliveries';

export default {
    name: 'PauseButton',
    components: {
        ResumeDeliveries,
    },
    props: {
        subscription: {
            required: true,
            type: Object,
        },
    },
    computed: {
        ...mapGetters({
            pauseAllowed: 'account/getAllowPaused',
        }),
        canBePaused() {
            return this.pauseAllowed && this.subscription.status === SUBSCRIPTION_STATUS_ACTIVE;
        },
    },
};
</script>
